"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMotorCommands = void 0;
var HandleCarUsageConfirmationPopupCommand_1 = require("./HandleCarUsageConfirmationPopupCommand");
var CheckAndNavigateGreenCard_1 = require("./CheckAndNavigateGreenCard");
var CheckRegistrationNumberAndNavigateCommand_1 = require("./CheckRegistrationNumberAndNavigateCommand");
var CheckSubscriptionStartDateAndNavigateCommand_1 = require("./CheckSubscriptionStartDateAndNavigateCommand");
var CheckAdditionalDriverCommand_1 = require("./CheckAdditionalDriverCommand");
var CheckNavigateToAddCarCommand_1 = require("./CheckNavigateToAddCarCommand");
var CheckPremiumIsNotCalculatedCommand_1 = require("./CheckPremiumIsNotCalculatedCommand");
var DeselectCarCommand_1 = require("./DeselectCarCommand");
var HandleInteractionChangedAndValidateRegistrationNumberCommand_1 = require("./HandleInteractionChangedAndValidateRegistrationNumberCommand");
var RemoveDriverByPersonId_1 = require("./RemoveDriverByPersonId");
var SaveDriversNameCommand_1 = require("./SaveDriversNameCommand");
var ProcessMyLicenceResponseCommand_1 = require("../../annual/motor/ProcessMyLicenceResponseCommand");
var addMotorCommands = function (extensions) {
    extensions.journeyComponents.addCommand({
        id: "handleCarUsageConfirmationPopup",
        component: HandleCarUsageConfirmationPopupCommand_1.HandleCarUsageConfirmationPopupCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkAndNavigateGreenCard",
        component: CheckAndNavigateGreenCard_1.CheckAndNavigateGreenCard
    });
    extensions.journeyComponents.addCommand({
        id: "checkAdditionalDriver",
        component: CheckAdditionalDriverCommand_1.CheckAdditionalDriverCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkNavigateToAddCar",
        component: CheckNavigateToAddCarCommand_1.CheckNavigateToAddCarCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkPremiumIsNotCalculated",
        component: CheckPremiumIsNotCalculatedCommand_1.CheckPremiumIsNotCalculatedCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkRegistrationNumberAndNavigate",
        component: CheckRegistrationNumberAndNavigateCommand_1.CheckRegistrationNumberAndNavigateCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkSubscriptionStartDateAndNavigate",
        component: CheckSubscriptionStartDateAndNavigateCommand_1.CheckSubscriptionStartDateAndNavigateCommand
    });
    extensions.journeyComponents.addCommand({
        id: "deselectCar",
        component: DeselectCarCommand_1.DeselectCarCommand
    });
    extensions.journeyComponents.addCommand({
        id: "handleInteractionChangedAndValidateRegistrationNumber",
        component: HandleInteractionChangedAndValidateRegistrationNumberCommand_1.HandleInteractionChangedAndValidateRegistrationNumberCommand
    });
    extensions.journeyComponents.addCommand({
        id: "removeDriverByPersonId",
        component: RemoveDriverByPersonId_1.RemoveDriverByPersonId
    });
    extensions.journeyComponents.addCommand({
        id: "saveDriversName",
        component: SaveDriversNameCommand_1.SaveDriversNameCommand
    });
    extensions.journeyComponents.addCommand({
        id: "processMyLicenceResponse",
        component: ProcessMyLicenceResponseCommand_1.ProcessMyLicenceResponseCommand
    });
};
exports.addMotorCommands = addMotorCommands;
//# sourceMappingURL=index.js.map